<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <fai icon="user"/>&nbsp;Registrar Movimiento
        </div>
      </div>
      <div class="card-body pb-5">
        <!--begin: Details -->
        <div class="row mt-4">
          <div class="col-sm-6">
            <h4 class="font-info">Datos Generales</h4>
            <h5>Información de cuenta: {{ this.avaliable }}</h5>
          </div>
        </div>
        <sys-form :inputs="movement_details"/>
        <!--end: Details -->
        <hr class="mt-4"/>
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-secondary" @click="$router.push({ name: 'movements' })">
          <fai icon="reply"/> Cancelar
        </button>
        <button class="btn btn-success" :class="{ 'disabled': form.isSaving }" @click="saveForm">
          <fai :icon="['far','edit']"/> Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import movementsService from '@/services/movements'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'

export default {
  name: 'MovementCreate',

  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      avaliable: '',
      movement_details: {
        colaborator_id: {
          name: 'Colaborador',
          value: '',
          type: 'select',
          options: [],
          size: 6,
          validate: 'required'
        },
        account_id: {
          name: 'Cuenta',
          value: '',
          type: 'select',
          options: [],
          size: 6,
          validate: 'required'
        },
        income: {
          name: 'Estatus',
          value: '',
          type: 'select',
          options: [
            { value: 1, text: 'Aportación' },
            { value: 0, text: 'Retiro' }
          ]
        },
        confirm_date: {
          name: 'Fecha Confirmación',
          value: '',
          type: 'date'
        },
        amount: {
          name: 'Monto del movimiento',
          hint: 'Monto',
          value: '',
          type: 'number'
        },
        total: {
          name: '¿Es Total?',
          value: '',
          type: 'select',
          options: [
            { value: 1, text: 'Sí' },
            { value: 0, text: 'No' }
          ]
        }
      }
    }
  },

  created: function () {
    this.loaded = false
    movementsService.listColabs().then(res => {
      this.movement_details.colaborator_id.options = res.data.map(colab => {
        return { value: colab.id, text: colab.name }
      })
    })
    this.movement_details.colaborator_id.value = { value: null, text: 'Seleccione un Colaborador' }
    this.movement_details.account_id.value = { value: null, text: 'Seleccione una Cuenta' }
    this.movement_details.income.value = { value: 0, text: 'Retiro' }
    this.movement_details.total.value = { value: 0, text: 'No' }
    this.loaded = true
  },

  methods: {
    saveForm: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let movementInfo = { ...this.movement_details }

          let body = this.processForm(movementInfo)
          let service = movementsService.post(body)

          this.sendForm(service).then(res => {
            this.$router.push({ name: 'movements', props: { movement: res } })
          }).catch(err => {
            this.$swal(err.data.message, 'Favor de checar el monto', {
              icon: 'error'
            })
          })
        }
      })
    }
  },
  watch: {
    'movement_details.colaborator_id.value': function (newColab, oldColab) {
      if (!newColab.value) {
        this.movement_details.amount.value = ''
        this.movement_details.confirm_date.value = ''
        return
      }

      let id = newColab.value
      movementsService.getAccountsList(id).then(res => {
        this.movement_details.account_id.options = res.data.map(account => {
          return { value: account.id, text: 'Id: ' + account.id + ' total: $' + (account.amount).toFixed(2) + ' disponible: $' + (account.amount_avaliable).toFixed(2) }
        })
      })
    },
    'movement_details.account_id.value': function (newAccount, oldAccount) {
      if (!newAccount.value) {
        this.movement_details.amount.value = ''
        this.movement_details.confirm_date.value = ''
      } else {
        this.avaliable = newAccount.text
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/movements/MovementCreate.vue